import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  // 导入
  importExcel({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/disciplineCategory/importExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导出
  exportData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/disciplineCategory/exportData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/disciplineCategory/findList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getBigSpecialityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/disciplineCategory/getBigSpecialityList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getSmallSpecialityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/disciplineCategory/getSmallSpecialityList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/disciplineCategory/deleteById`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
